import { render, staticRenderFns } from "./pt-img.vue?vue&type=template&id=4764a965"
import script from "./pt-img.vue?vue&type=script&lang=js"
export * from "./pt-img.vue?vue&type=script&lang=js"
import style0 from "./pt-img.vue?vue&type=style&index=0&id=4764a965&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports